<template>
  <div class="regions">
    <div>
      <h1>Manage Region: {{region.region_name}}</h1>
      <div class="box">
        <form class="form" v-on:submit.prevent="addPoint">
          <fieldset>
            <div class="form-wrap">
              <div>
                <label for="pickup_point_name">Pickup Points</label>
                <v-select
                  index="id"
                  label="pickup_point_name"
                  :options="pickup_points"
                  :v-model="newPoint.pick_up_point_id"
                  @change="updatePoint"
                />
              </div>
              <div class="form-submit-inline">
                <template v-if="this.$data.loading">
                  <button type="submit" class="button" disabled><span>Adding pickup point...</span></button>
                </template>
                <template v-else>
                  <button type="submit" class="button"><span>Add pickup point to region</span></button>
                </template>
              </div>
            </div>
          </fieldset>
        </form>
        <table class="table" cellspacing="0" cellpadding="0" v-if="region.pick_up_points">
          <thead v-if="region.pick_up_points.length > 0">
            <tr>
              <th>Point Name</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="point of region.pick_up_points" :key="point.id">
              <td>{{point.pickup_point_name}}</td>
              <td class="table-action"><a v-on:click="deletePoint(region.id, point.id)" class="icon icon--delete">Delete</a></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'points-edit',
    components: {
    },
    data () {
      return {
        loading: false,
        region: [],
        pickup_points: [],
        new_pickup_up_point: null,
        newPoint: {
          pickup_point_region: parseInt(this.$route.params.id),
          pickup_point_id: null,
        },
      }
    },
    created () {
      this.getRegion(this.$route.params.id),
      this.getPoints()
    },
    methods: {
      updatePoint(data) {
        this.$data.newPoint.pickup_point_id = data
      },
      getRegion(data) {
        this.$store.dispatch('setLoadStatus')
        fetch( this.$api + 'pickup/regions/' + data, {
          headers: {
            'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.$store.dispatch('setLoadStatus')
          this.$data.region = response.data[0]
        })
      },
      getPoints() {
        this.$store.dispatch('setLoadStatus')
        fetch( this.$api + 'pickup/', {
          headers: {
            'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.$store.dispatch('setLoadStatus')
          this.$data.pickup_points = response.data
        })
      },
      addPoint() {
        this.$data.loading = true
        fetch(this.$api + 'pickup/add', {
          method: 'POST',
          body: JSON.stringify(this.$data.newPoint),
          headers:{
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.getRegion(this.$route.params.id)
          this.$notify({
            type: 'success',
            title: response.message
          });
          this.$data.loading = false
        })
      },
      deletePoint(regionId, pointId) {
        this.$store.dispatch('setLoadStatus')
        fetch(this.$api + 'pickup/remove/', {
          method: 'POST',
          body: JSON.stringify(
            {
              pickup_point_region: regionId,
              pickup_point_id: pointId,
            }
          ),
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.errors = response.errors
          if(response.success == true) {

            this.$notify({
              type: 'success',
              title: response.message
            });

          } else if (response.errors) {
            this.$notify({
              type: 'error',
              title: response.message
            });

          } else {
            this.$notify({
              type: 'error',
              title: response.Error
            });
          }
          this.getRegion(this.$route.params.id)
          this.$store.dispatch('setLoadStatus')
        });
      },
    }
  }
</script>
